import { types } from './definitions';

// Sets the global user data object on window for chat widget script to consume
export const setGlobalUserData = ({
  account,
  user,
  csrf,
  realm,
}: types.SetGlobalUserDataArgs): void => {
  window.account = {
    sid: account.sid,
  };

  window.user = {
    sid: user.sid,
    email: user.emailAddr,
    fullName: `${user.firstName} ${user.lastName}`,
    csrf,
    realm,
  };
};

// Sets the chat widget script on the OSC page
export const setChatWidgetScript = ({
  src,
  onError,
  onLoad,
}: types.SetChatWidgetScriptArgs): HTMLScriptElement => {
  const script = document.createElement('script');

  script.src = src;
  script.async = true;

  document.body.appendChild(script);

  if (onError) {
    script.onerror = onError;
  }

  if (onLoad) {
    script.onload = onLoad;
  }

  return script;
};
